import { render } from "./OrthoUserProfile.vue?vue&type=template&id=3f25fc10"
import script from "./OrthoUserProfile.vue?vue&type=script&lang=js"
export * from "./OrthoUserProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__